import NewProductTHead from '../../../common/theads/NewProductTHead'
import { removeItemFromSpecialPackage, selectClientSpecialPackageItems } from '../../../../features/client/clientSlice'
import { useDispatch, useSelector } from 'react-redux'

export default function ClientSpecialMyItems() {

    const dispatch = useDispatch()
    const specialPackageItems = useSelector(selectClientSpecialPackageItems)

    return (
        <>
            <NewProductTHead isShowPrice={false}/>
            <div className="flex-1 overflow-hidden h-full rounded">
                <div className='h-full rounded overflow-y-auto'>
                    <div>
                        <div className='flex-1 overflow-hidden h-full rounded'>
                            <div className="p-2 h-full rounded overflow-y-auto">
                                <div className="grid grid-cols-1 gap-2">
                                    {specialPackageItems?.map((item) => {
                                        const firstWord = item.categoryInfo?.categoryName?.split(" ")[0] || "";
                                        return (
                                            <div key={item.id} className='cursor-pointer transition-colors rounded border'>
                                                <div className="border border-gray-200 flex flex-col p-2.5 space-y-1 rounded bg-gray-100 transition-colors">
                                                    <div className="grid [grid-template-columns:2fr_1fr_0.5fr_0.5fr_auto] gap-2 w-full text-[12px] items-center">
                                                        <div className="font-medium truncate">{`${firstWord} | ${item.name}`}</div>
                                                        <div className="truncate">{item.sizeInfo.size}</div>
                                                        <div 
                                                            className="flex justify-center"
                                                            onClick={() => {dispatch(removeItemFromSpecialPackage(item.id))}}
                                                        >Remove</div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
